import { action } from 'satcheljs';

import type { MessageExtensionType } from 'owa-graph-schema';
import type { MailboxInfo } from 'owa-client-types';

type OpenMessageExtensionsFlyout = {
    flyoutButtonElementId: string;
    targetWindow: Window;
    formId: string;
    readingPaneItemId: string;
    messageExtensionType: MessageExtensionType;
    mailboxInfo?: MailboxInfo;
    element?: HTMLElement;
};

export interface OnClickMessageExtensionFlyoutButtonActionMessage {
    flyoutButtonElementId: string;
    targetWindow: Window;
    formId: string;
    readingPaneItemId: string;
    messageExtensionType: MessageExtensionType;
    mailboxInfo: MailboxInfo | undefined;
    element: HTMLElement | undefined;
}
export const onClickMessageExtensionFlyoutButton: ({
    flyoutButtonElementId,
    targetWindow,
    formId,
    readingPaneItemId,
    messageExtensionType,
    mailboxInfo,
    element,
}: OpenMessageExtensionsFlyout) => OnClickMessageExtensionFlyoutButtonActionMessage = action(
    'onClickMessageExtensionFlyoutButton',
    ({
        flyoutButtonElementId,
        targetWindow,
        formId,
        readingPaneItemId,
        messageExtensionType,
        mailboxInfo,
        element,
    }: OpenMessageExtensionsFlyout): OnClickMessageExtensionFlyoutButtonActionMessage => ({
        flyoutButtonElementId,
        targetWindow,
        formId,
        readingPaneItemId,
        messageExtensionType,
        mailboxInfo,
        element,
    })
);
